<div class="modal-content">
    <div class="modal-body">
        <div class="modal-toggle-wrapper">
            <!-- Imagen de advertencia -->
            <ul class="modal-img">
                <li> <img src="assets/images/gif/danger.gif" alt="error"></li>
            </ul>

            <!-- Título de la modal -->
            <h4 class="text-center pb-2">¿Estás seguro de que deseas eliminar este registro?</h4>

            <!-- Descripción del mensaje -->
            <p class="text-center">
                Esta acción no se puede deshacer. ¿Deseas continuar con la eliminación?
            </p>

            <!-- Botones de confirmación -->
            <div class="text-center">
                <button class="btn btn-secondary me-2" type="button" (click)="modalService.dismissAll()">Cancelar</button>
                <button class="btn btn-danger ms-2" type="button" (click)="confirmDelete()">Confirmar</button>
            </div>
        </div>
    </div>
</div>
